export type WindowOptimizelyDecisions = Record<string, unknown>

type ExposeOptimizelyDecisionsOptions = {
  merge?: boolean
}

export function exposeOptimizelyDecisionsOnWindow(
  decisions: WindowOptimizelyDecisions | null | undefined,
  { merge = false }: ExposeOptimizelyDecisionsOptions = {},
): void {
  if (typeof window === 'undefined') {
    return
  }

  const nextDecisions = decisions ?? {}

  window.optimizely_decision = merge
    ? {
        ...(window.optimizely_decision ?? {}),
        ...nextDecisions,
      }
    : nextDecisions
}
